import {
  AudioLines,
  BookOpen,
  BookOpenIcon,
  Bot,
  CreditCardIcon,
  DownloadIcon,
  FileText,
  FilmIcon,
  FolderPlusIcon,
  GraduationCap,
  Languages,
  LifeBuoy,
  Lightbulb,
  Map,
  MicIcon,
  Monitor,
  Newspaper,
  Presentation,
  RocketIcon,
  SendHorizonalIcon,
  ShieldCheck,
  UserRound,
  Users,
  Video
} from 'lucide-react';

import { routes } from '@workspace/routes';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  XIcon,
  YouTubeIcon
} from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Tools',
    items: [
      {
        title: 'AI Product Video Maker',
        description: 'Create stunning product videos with AI',
        icon: <Video className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiProductVideoMaker}`,
        external: false
      },
      {
        title: 'Product Demo Video Maker',
        description: 'Professional demos in minutes',
        icon: <Monitor className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.ProductDemoVideoMaker}`,
        external: false
      },
      {
        title: 'AI Video Script Generator',
        description: 'Auto-generate video scripts',
        icon: <FileText className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiVideoScriptGenerator}`,
        external: false
      },
      {
        title: 'AI Tutorial Video Maker',
        description: 'Build tutorials effortlessly',
        icon: <BookOpen className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiTutorialVideoMaker}`,
        external: false
      },
      {
        title: 'AI Educational Video Maker',
        description: 'Educational content made easy',
        icon: <GraduationCap className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiEducationalVideoMaker}`,
        external: false
      },
      {
        title: 'AI Screen Recorder',
        description: 'Record your screen in the browser',
        icon: <Bot className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiScreenRecorder}`,
        external: false
      },
      {
        title: 'AI Training Videos',
        description: 'Create training videos with AI',
        icon: <Presentation className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiTrainingVideos}`,
        external: false
      },
      {
        title: 'AI Voiceover Generator',
        description: 'Script and narrate your videos',
        icon: <MicIcon className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiVoiceoverGenerator}`,
        external: false
      },
      {
        title: 'AI Avatar Video Maker',
        description: 'Avatar presenter for your recordings',
        icon: <Users className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiAvatarVideoMaker}`,
        external: false
      },
      {
        title: 'AI Video Clone',
        description: 'Clone yourself into your videos',
        icon: <UserRound className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiVideoClone}`,
        external: false
      },
      {
        title: 'AI Video Translator',
        description: 'Native voiceovers in 70+ languages',
        icon: <Languages className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiVideoTranslator}`,
        external: false
      },
      {
        title: 'AI Voice Cloning',
        description: 'Narrate in your own cloned voice',
        icon: <AudioLines className="size-5 shrink-0" />,
        href: `${routes.marketing.tools.AiVoiceCloning}`,
        external: false
      }
    ]
  },
  {
    title: 'Pricing',
    href: routes.marketing.Pricing,
    external: false
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
  {
    title: 'About',
    href: routes.marketing.About,
    external: false
  },
  {
    title: 'Resources',
    items: [
      {
        title: 'Contact',
        description: 'Reach out for assistance',
        icon: <SendHorizonalIcon className="size-5 shrink-0" />,
        href: routes.marketing.Contact,
        external: false
      },
      {
        title: 'Feature Requests',
        description: 'Submit ideas and vote on feature requests',
        icon: <Lightbulb className="size-5 shrink-0" />,
        href: 'https://feedback.videomule.ai/b/y0g3dxme/feature-ideas',
        external: true
      },
      {
        title: 'Roadmap',
        description: 'See what is planned and in progress',
        icon: <Map className="size-5 shrink-0" />,
        href: 'https://feedback.videomule.ai/roadmap',
        external: true
      },
      {
        title: 'Docs',
        description: 'Learn how to use our platform',
        icon: <BookOpenIcon className="size-5 shrink-0" />,
        href: routes.marketing.Docs,
        external: false
      },
      {
        title: 'Changelog',
        description: 'New features and improvements',
        icon: <Newspaper className="size-5 shrink-0" />,
        href: routes.marketing.Changelog,
        external: false
      },
      {
        title: 'Security',
        description: 'How we protect your data',
        icon: <ShieldCheck className="size-5 shrink-0" />,
        href: routes.marketing.Security,
        external: false
      }
      // {
      //   title: 'API Reference',
      //   description: 'Build integrations with our API',
      //   icon: <CodeIcon className="size-5 shrink-0" />,
      //   href: baseUrl.PublicApi,
      //   external: true
      // }
    ]
  }
];

export const FOOTER_LINKS = [
  {
    title: 'Tools',
    links: [
      {
        name: 'AI Product Video Maker',
        href: `${routes.marketing.tools.AiProductVideoMaker}`,
        external: false
      },
      {
        name: 'Product Demo Video Maker',
        href: `${routes.marketing.tools.ProductDemoVideoMaker}`,
        external: false
      },
      {
        name: 'AI Video Script Generator',
        href: `${routes.marketing.tools.AiVideoScriptGenerator}`,
        external: false
      },
      {
        name: 'AI Tutorial Video Maker',
        href: `${routes.marketing.tools.AiTutorialVideoMaker}`,
        external: false
      },
      {
        name: 'AI Educational Video Maker',
        href: `${routes.marketing.tools.AiEducationalVideoMaker}`,
        external: false
      },
      {
        name: 'AI Screen Recorder',
        href: `${routes.marketing.tools.AiScreenRecorder}`,
        external: false
      },
      {
        name: 'AI Training Videos',
        href: `${routes.marketing.tools.AiTrainingVideos}`,
        external: false
      },
      {
        name: 'AI Voiceover Generator',
        href: `${routes.marketing.tools.AiVoiceoverGenerator}`,
        external: false
      },
      {
        name: 'AI Avatar Video Maker',
        href: `${routes.marketing.tools.AiAvatarVideoMaker}`,
        external: false
      },
      {
        name: 'AI Video Clone',
        href: `${routes.marketing.tools.AiVideoClone}`,
        external: false
      },
      {
        name: 'AI Video Translator',
        href: `${routes.marketing.tools.AiVideoTranslator}`,
        external: false
      },
      {
        name: 'AI Voice Cloning',
        href: `${routes.marketing.tools.AiVoiceCloning}`,
        external: false
      }
    ]
  },

  {
    title: 'Resources',
    links: [
      { name: 'Contact', href: routes.marketing.Contact, external: false },
      {
        name: 'Feature Requests',
        href: 'https://feedback.videomule.ai/b/y0g3dxme/feature-ideas',
        external: true
      },
      {
        name: 'Roadmap',
        href: 'https://feedback.videomule.ai/roadmap',
        external: true
      },
      { name: 'Docs', href: routes.marketing.Docs, external: false },
      { name: 'Changelog', href: routes.marketing.Changelog, external: false },
      { name: 'Security', href: routes.marketing.Security, external: false }
      //{ name: 'API Reference', href: baseUrl.PublicApi, external: true }
    ]
  },
  {
    title: 'About',
    links: [
      {
        name: 'Pricing',
        href: routes.marketing.Pricing,
        external: false
      },
      { name: 'About us', href: routes.marketing.About, external: false },
      { name: 'Blog', href: routes.marketing.Blog, external: false }
      // { name: 'Careers', href: routes.marketing.Careers, external: false }
    ]
  },
  {
    title: 'Legal',
    links: [
      {
        name: 'Terms of Use',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Privacy Policy',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookie Policy',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: 'https://x.com/videomule_ai',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/videomule/',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61585117719812',
    icon: <FacebookIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/videomule/',
    icon: <InstagramIcon className="size-4 shrink-0" />
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@VideoMule_AI',
    icon: <YouTubeIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <RocketIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Account Creation',
        href: '/docs',
        items: []
      },
      {
        title: 'Chrome Extension Screen Recorder',
        href: '/docs/chrome-extension-screen-recorder',
        items: []
      },
      {
        title: 'Managing Projects',
        href: '/docs/managing-projects',
        items: []
      }
    ]
  },
  {
    title: 'Account & Billing',
    icon: <CreditCardIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Plans and Usage Limits',
        href: '/docs/plans-usage-limits',
        items: []
      },
      {
        title: 'Credit Packs',
        href: '/docs/credit-packs',
        items: []
      },
      {
        title: 'Capabilities and Limits',
        href: '/docs/capabilities-and-limits',
        items: []
      },
      {
        title: 'Tracking Usage and Billing',
        href: '/docs/usage-and-billing',
        items: []
      },
      {
        title: 'Managing Your Organization',
        href: '/docs/managing-organization',
        items: []
      },
      {
        title: 'Account and Security',
        href: '/docs/account-settings-and-security',
        items: []
      }
    ]
  },
  {
    title: 'Creating a Project',
    icon: <FolderPlusIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Creating a Video Project',
        href: '/docs/create-project',
        items: []
      },
      {
        title: 'Video Upload and Script Generation',
        href: '/docs/video-upload-and-script-generation',
        items: []
      }
    ]
  },
  {
    title: 'Script Editor',
    icon: <FileText className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Reviewing and Editing Your Script',
        href: '/docs/reviewing-and-editing-your-script',
        items: []
      },
      {
        title: 'Script Templates',
        href: '/docs/script-templates',
        items: []
      },
      {
        title: 'Script Versions and Review',
        href: '/docs/script-versions-and-review',
        items: []
      },
      {
        title: 'Generation Effects',
        href: '/docs/generation-effects',
        items: []
      },
      {
        title: 'Generating Your Video',
        href: '/docs/generating-your-video',
        items: []
      }
    ]
  },
  {
    title: 'Video Editor',
    icon: <FilmIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'AI Video Editor',
        href: '/docs/ai-video-editor',
        items: []
      },
      {
        title: 'Timeline Editing',
        href: '/docs/timeline-editing',
        items: []
      },
      {
        title: 'Captions',
        href: '/docs/captions',
        items: []
      },
      {
        title: 'Canvas and Overlays',
        href: '/docs/canvas-and-overlays',
        items: []
      },
      {
        title: 'Zoom and Cursor Tracking',
        href: '/docs/zoom-and-cursor-tracking',
        items: []
      },
      {
        title: 'Audio and Background Music',
        href: '/docs/audio-editing',
        items: []
      },
      {
        title: 'Media Library',
        href: '/docs/media-library',
        items: []
      },
      {
        title: 'Saving and History',
        href: '/docs/saving-and-history',
        items: []
      }
    ]
  },
  {
    title: 'Exporting',
    icon: <DownloadIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Rendering and Exporting',
        href: '/docs/video-rendering-and-exporting',
        items: []
      }
    ]
  },
  {
    title: 'Voice Library',
    icon: <MicIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Browsing and Selecting Voices',
        href: '/docs/voice-library',
        items: []
      },
      {
        title: 'Bring Your Own ElevenLabs Voice',
        href: '/docs/elevenlabs-voice-cloning',
        items: []
      }
    ]
  },
  {
    title: 'Avatar Library',
    icon: <Users className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Browsing Avatars and Looks',
        href: '/docs/avatar-library',
        items: []
      },
      {
        title: 'Training a Custom Avatar',
        href: '/docs/training-a-custom-avatar',
        items: []
      },
      {
        title: 'Avatar Quality Tiers',
        href: '/docs/avatar-quality-tiers',
        items: []
      },
      {
        title: 'Placing Avatars in Your Video',
        href: '/docs/placing-avatars-in-your-video',
        items: []
      }
    ]
  },
  {
    title: 'Translation',
    icon: <Languages className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Translating Your Project',
        href: '/docs/translating-your-project',
        items: []
      }
    ]
  },
  {
    title: 'Help',
    icon: <LifeBuoy className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Troubleshooting',
        href: '/docs/troubleshooting',
        items: []
      }
    ]
  }
  // {
  //   title: 'Guides',
  //   icon: <BookIcon className="size-4 shrink-0 text-muted-foreground" />,
  //   items: [
  //     {
  //       title: 'Using MDX',
  //       href: '/docs/using-mdx',
  //       items: []
  //     }
  //   ]
  // }
];
